import { IPLink, IPMessageBar, IPMessageBarType, IPSpinner, IPSpinnerSize, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { useTranslation } from 'react-i18next';

export type ExpressionStatus =
  | { kind: 'empty' }
  | { kind: 'validating' }
  | { kind: 'valid'; example?: string }
  | { kind: 'error'; action?: { text: string; onClick: () => void } };

interface IExpressionStatusStripProps {
  id: string;
  status: ExpressionStatus;
}

const ExpressionStatusStrip = (props: IExpressionStatusStripProps) => {
  const { t } = useTranslation(['kpis']);
  const { status } = props;

  if (status.kind === 'validating') {
    return <IPSpinner id={props.id} size={IPSpinnerSize.xSmall} label={t('kpis:Expression.Validating')} />;
  }

  if (status.kind === 'valid') {
    const text = status.example
      ? `${t('kpis:Expression.Valid')} - ${t('kpis:Expression.ExamplePrefix')} ${status.example}`
      : t('kpis:Expression.Valid');

    return (
      <IPMessageBar
        id={props.id}
        messageBarType={IPMessageBarType.success}
        isMultiline={false}
        delayedRender={false}
      >
        {text}
      </IPMessageBar>
    );
  }

  if (status.kind === 'error') {
    return (
      <IPStack id={props.id} styles={{ root: { minHeight: 20 } }} verticalAlign="center">
        {status.action && <IPLink onClick={status.action.onClick}>{status.action.text}</IPLink>}
      </IPStack>
    );
  }

  return (
    <IPStack id={props.id} styles={{ root: { minHeight: 20 } }} verticalAlign="center">
      <IPText variant="small">{t('kpis:Expression.Hint')}</IPText>
    </IPStack>
  );
};

export default ExpressionStatusStrip;
